module.exports = __webpack_public_path__ + "img/signup-parent-type.299f1a2a.svg";